import {
  faChartPieSimpleCircleDollar,
  faScaleBalanced,
  faShoppingCart,
  IconDefinition,
} from "@fortawesome/pro-light-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import React from "react"
import { useTranslation } from "react-i18next"

export interface StatsProps {
  resultado?: string
  margen?: string
  ventas?: string
  loading?: boolean
}

const Stat: React.FC<{
  label: string
  value: string
  testId?: string
  icon: IconDefinition
  iconColor?: string
  bgGradient?: string
}> = ({ label, value, testId, icon, iconColor = "", bgGradient = "" }) => {
  return (
    <div
      className={`tw-flex tw-items-center tw-gap-2 tw-rounded-md tw-border tw-border-slate-200 tw-bg-white tw-px-3 tw-py-2 tw-shadow-sm hover:tw-shadow-lg tw-transition-shadow tw-duration-200 tw-text-left tw-bg-gradient-to-r ${bgGradient} tw-to-white tw-to-35%`}
      data-testid={testId}
    >
      <FontAwesomeIcon
        icon={icon}
        className={`tw-px-2 tw-size-6 ${iconColor}`}
      />
      <div className='tw-flex tw-flex-col tw-justify-center tw-gap-0.5'>
        <span className='tw-text-sm tw-tracking-wide tw-text-slate-500'>
          {label}
        </span>
        <span
          className='tw-text-xl tw-font-medium tw-text-primary tw-tabular-nums data-[negative=true]:tw-text-danger'
          data-negative={Boolean(value.includes("-"))}
        >
          {value}
        </span>
      </div>
    </div>
  )
}

export const Stats: React.FC<StatsProps> = ({
  resultado,
  margen,
  ventas,
  loading,
}) => {
  const { t } = useTranslation()

  return (
    <div
      className='tw-w-fit'
      role='region'
      aria-label='Resumen Pérdidas y Ganancias'
    >
      <div className='tw-p-3'>
        <div className='tw-grid tw-grid-cols-1 tw-gap-4'>
          {loading ? (
            <>
              <div className='tw-h-16 tw-w-60 tw-animate-pulse tw-rounded-md tw-bg-slate-200' />
              <div className='tw-h-16 tw-w-60 tw-animate-pulse tw-rounded-md tw-bg-slate-200' />
              <div className='tw-h-16 tw-w-60 tw-animate-pulse tw-rounded-md tw-bg-slate-200' />
            </>
          ) : (
            <>
              <Stat
                label={t("informes.perdidasGanancias.stats.resultYear")}
                value={resultado || "-"}
                testId='stat-resultado'
                icon={faScaleBalanced}
                iconColor='tw-text-green-600'
                bgGradient='tw-from-green-50'
              />
              <Stat
                label={t("informes.perdidasGanancias.stats.margin")}
                value={margen || "-"}
                testId='stat-margen'
                icon={faChartPieSimpleCircleDollar}
                iconColor='tw-text-blue-600'
                bgGradient='tw-from-blue-50'
              />
              <Stat
                label={t("informes.perdidasGanancias.stats.sales")}
                value={ventas || "-"}
                testId='stat-ventas'
                icon={faShoppingCart}
                iconColor='tw-text-purple-600'
                bgGradient='tw-from-purple-50'
              />
            </>
          )}
        </div>
      </div>
    </div>
  )
}
